export const buildQueryString = (
  experiments?: string[],
  successType?: string,
  urlParams?: URLSearchParams,
  checkoutMode?: 'Headless' | 'LargeBackground',
) => {
  const donateUrlParams = new URLSearchParams();

  const trimmedSuccessType = successType?.trim();
  const trimmedExperiments = experiments
    ?.map(e => e.trim())
    .filter(e => e !== '');

  if (
    trimmedExperiments &&
    trimmedExperiments.length > 0 &&
    trimmedSuccessType
  ) {
    donateUrlParams.append('experiments', trimmedExperiments.join(','));
    donateUrlParams.append('successType', trimmedSuccessType);
  }

  if (checkoutMode) {
    donateUrlParams.append('checkoutMode', checkoutMode);
  }

  const utmSource = urlParams?.get('utm_source');
  if (utmSource) {
    donateUrlParams.append('reference', utmSource);
  }

  return donateUrlParams.toString() ? `?${donateUrlParams.toString()}` : '';
};
